import { apiGet } from './api';
import API_CONFIG from '../config/api';

/**
 * Lista atletas para la página Miembros (nombre, apellido, región, total, club).
 * @param {Object} params - { search, region, page, limit }
 * @returns {Promise<{ items: Array }>}
 */
export const getAtletas = async (params = {}) => {
  const sp = new URLSearchParams();
  if (params.search) sp.set('search', params.search);
  if (params.region) sp.set('region', params.region);
  if (params.page) sp.set('page', String(params.page));
  if (params.limit) sp.set('limit', String(params.limit));
  const url = `${API_CONFIG.ENDPOINTS.ATLETAS.LISTAR}?${sp.toString()}`;
  const res = await apiGet(url);
  const data = await res.json();
  if (!res.ok || data.success === false) {
    throw new Error(data.error || data.message || 'Error al cargar atletas');
  }
  return {
    items: data.items || [],
    total: data.total,
    page: data.page,
    // Si el backend aún no pagina (versión anterior), se considera una sola página
    totalPages: data.total_pages ?? 1,
  };
};
